import { render, staticRenderFns } from "./HomeCom.vue?vue&type=template&id=8cc09464&"
import script from "./HomeCom.vue?vue&type=script&lang=js&"
export * from "./HomeCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports